import React from "react";
import PropTypes from "prop-types";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import "./styles.scss";

const Error = ({ icon, message, subtitle, children }) => {
  return (
    <Col className="col-12 text-center h-100 d-flex align-items-center">
      <Container fluid>
        <Row>
          <Col className="col-12 text-center">
            <img className="error-img" src={icon} alt={message} />
          </Col>
          <Col className="col-12 text-center">
            <span className="error-message">{message}</span>
          </Col>
          {subtitle && (
            <Col className="col-12 text-center mt-3">
              <span className="error-subtitle">{subtitle}</span>
            </Col>
          )}
        </Row>
        {children && <Row>{children}</Row>}
      </Container>
    </Col>
  );
};

Error.propTypes = {
  icon: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

Error.defaultProps = {
  title: "Error",
  message: "Not Found",
};

export default Error;
